import { http } from './config'

export default {
  cadastrarendereco:(endereco) => {
    return http.post('endereco.php',(endereco));
  },
  listandoEnderecos:(cd) => {
    return http.get('endereco.php?cd_usu='+cd);
  },
  deletarEnderecos:(endereco)=>{
    return http.delete('endereco.php',(endereco)) 
  },
  alterarusuario:(endereco)=>{
    return http.delete('endereco.php',(endereco)) 
  },
  atualizaendereco:(endereco)=>{
    return http.put('endereco_atualiza.php',(endereco)) 
  }
  
}